import { WithId } from '@common/typescript/objects/WithId';

export enum SearchObjectType {
	Patient,
	User,
	Doctor,
	Location
}

export interface SearchObject extends WithId {
	type: SearchObjectType;
	name: string;
	avatar: string;
	path?: string;
	group?: boolean;
	scrollIntoView?: boolean;
}

export const SearchObjectTypePathName = {
	[SearchObjectType.Patient]: 'patient',
	[SearchObjectType.User]: 'user',
	[SearchObjectType.Doctor]: 'doctor',
	[SearchObjectType.Location]: 'location',
};

export const SearchObjectTypeIcon = {
	[SearchObjectType.Patient]: 'fa fa-heartbeat',
	[SearchObjectType.User]: 'fa fa-user-o',
	[SearchObjectType.Doctor]: 'fa fa-user-md',
	[SearchObjectType.Location]: 'fa fa-hospital-o',
};

export const SearchObjectTypeColor = {
	[SearchObjectType.Patient]: '#ffe1e1',
	[SearchObjectType.User]: '#fffde7',
	[SearchObjectType.Doctor]: '#e1ffe2',
	[SearchObjectType.Location]: '#dce2ff',
};
